import React, {PureComponent} from 'react';
import {Card, CardBody, CardImg, CardTitle} from 'reactstrap';
import PropTypes from 'prop-types';

import indirectTIPurchaser from './images/indirectTIPurchaser.jpg';
import cfo from './images/cfo.jpg';
import chro from './images/chro.jpg';
import consolidationManager from './images/consolidationManager.jpg';
import businessController from './images/businessController.jpg';
import indirectPurchaser from './images/indirectPurchaser.jpg';
import isHrProjectManager from './images/isHrProjectManager.jpg';
import payrollManager from './images/payrollManager.jpg';
import purchaseManager from './images/purchaseManager.jpg';
import recruitmentManager from './images/recruitmentManager.jpg';
import supplyChainManager from './images/supplyChainManager.jpg';
import treasuryManager from './images/treasuryManager.jpg';

import './FreelanceExamples.scss';

const freelances = [
  {img: indirectPurchaser.src, title: 'Acheteur indirect', universe: 'purchase'},
  {img: indirectTIPurchaser.src, title: 'Acheteur indirect TI', universe: 'purchase'},
  {img: supplyChainManager.src, title: 'Gestionnaire des opérations et de la logistique', universe: 'purchase'},
  {img: purchaseManager.src, title: 'Chargé de Projet - Achats', universe: 'purchase'},
  {img: businessController.src, title: 'Comptable Professionnel Agréé (CPA)', universe: 'finance'},
  {img: cfo.src, title: 'Directeur Financier', universe: 'finance'},
  {img: payrollManager.src, title: 'Conseiller(ère) en Ressources Humaines Agréés (CRHA)', universe: 'hr'},
  {img: chro.src, title: 'Conseiller(ère) en acquisition de talents', universe: 'hr'},
  {img: treasuryManager.src, title: 'Responsable trésorerie', universe: 'finance'},
  {img: consolidationManager.src, title: 'Responsable consolisation', universe: 'finance'},
  {img: isHrProjectManager.src, title: 'Chef de projet SIRH', universe: 'hr'},
  {img: recruitmentManager.src, title: 'Chargé de recrutement', universe: 'hr'},
];

export default class FreelanceExamples extends PureComponent {
  static propTypes = {
    universeCode: PropTypes.string
  };

  static defaultProps = {
    universeCode: null,
  };

  render() {
    const universeCode = this.props.universeCode;
    const filteredFeelances = (universeCode ?
      freelances.filter(freelance => freelance.universe === universeCode) : freelances
    ).slice(0, universeCode ? 4 : 8);

    return <section className="freelance-examples container text-center py-5">
      <h2 className="mb-5">Les profils les plus demandés{universeCode ? '' : ' des fonctions corporatives'}</h2>
      <ul className="row">
        {filteredFeelances.map((freelance, index) => (
          <Card className="col-6 col-md-3 px-3 px-md-5 bg-transparent" key={index} tag="li">
            <CardImg className="border border-white" src={freelance.img}/>
            <CardBody>
              <CardTitle tag="h3">{freelance.title}</CardTitle>
            </CardBody>
          </Card>
        ))}
      </ul>
    </section>;
  }
}
